import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getImpactRatingFormConfig = () => {
  return {
    ImpactId: {
      fieldId: 'ImpactId',
      formLabel: t('impactRatings.fields.Impact'),
    },
    RatedItemId: {
      fieldId: 'RatedItemId',
      formLabel: t('impactRatings.fields.Risk'),
    },
    CompletedBy: {
      fieldId: 'CompletedBy',
      formLabel: t('impactRatings.fields.CompletedBy'),
    },
    TestDate: {
      fieldId: 'TestDate',
      formLabel: t('impactRatings.fields.TestDate'),
      displayType: { displayType: 'date' },
    },
    Likelihood: {
      fieldId: 'Likelihood',
      formLabel: t('impactRatings.fields.Likelihood'),
      displayType: { displayType: 'rating', ratingKey: 'likelihood' },
      allowAsConditionSource: true,
    },
    Rating: {
      fieldId: 'Rating',
      formLabel: t('impactRatings.fields.Rating'),
      displayType: { displayType: 'rating', ratingKey: 'impact' },
      allowAsConditionSource: true,
    },
  } as const satisfies FormConfig;
};
